import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'fileSize'
})
export class FileSizePipe implements PipeTransform {

    transform(value: any, args?: string): any {
        let returnValue = '';
        switch (args) {
            case 'B':
                returnValue = value.toFixed(1) + 'B';
                break;
            case 'KB':
                returnValue = (value / 1024).toFixed(1) + 'KB';
                break;
            case 'MB':
                returnValue = (value / (1024 * 1024)).toFixed(1) + 'MB';
                break;
            default:
                let steps = 0;
                while (value > 1024 && steps < 2) {
                    value = value / 1024;
                    steps++;
                }
                const suffix = ['B', 'KB', 'MB', 'GB'];
                returnValue = value.toFixed(1) + suffix[steps];
                break;
        }
        return returnValue;
    }

}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/pipes/file-size.pipe.ts